import { Dispatch } from 'redux';
import {
  BLACKLIST_GET_START,
  BLACKLIST_GET_DATA,
  BLACKLIST_GET_END,
  BLACKLIST_DELETE,
} from '../type';

const API_URL = process.env.REACT_APP_API_URL;

export const getBlacklisted = (page: number, size: number): any => async (dispatch: Dispatch): Promise<any> => {
  dispatch({ type: BLACKLIST_GET_START });
  try {
    const token = localStorage.getItem('loginToken');
    const res = await fetch(`${API_URL}/blacklist/get-blacklisted/${page}/${size}`, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
    const data = await res.json();
    console.log('[Blacklist] GET response:', res.status, data);
    if (res.ok) {
      dispatch({ type: BLACKLIST_GET_DATA, payload: data });
      return { success: true, data };
    }
    dispatch({ type: BLACKLIST_GET_END, payload: data.message });
    return { success: false, message: data.message };
  } catch (err: any) {
    console.error('[Blacklist] GET error:', err);
    dispatch({ type: BLACKLIST_GET_END, payload: err.message });
    return { success: false, message: err.message };
  }
};

export const deleteBlacklisted = (id: number): any => async (dispatch: Dispatch): Promise<any> => {
  try {
    const token = localStorage.getItem('loginToken');
    const res = await fetch(`${API_URL}/blacklist/delete/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
    if (res.ok) {
      dispatch({ type: BLACKLIST_DELETE });
      return { success: true };
    }
    const data = await res.json().catch(() => ({}));
    return { success: false, message: data.message || 'Delete failed' };
  } catch (err: any) {
    return { success: false, message: err.message };
  }
};
